import api from '@/utils/axios';
import { unwrapItem } from '@/utils/apiHelpers';
import type { ApiOrderTracking } from './types';

export interface DriverLocationPayload {
  latitude: number;
  longitude: number;
  order_request_id?: number;
  heading?: number;
  speed?: number;
}

export async function getOrderTracking(orderRequestId: number): Promise<ApiOrderTracking> {
  const res = await api.get(`/order-requests/${orderRequestId}/tracking`);
  return unwrapItem<ApiOrderTracking>(res.data);
}

export async function sendDriverLocation(payload: DriverLocationPayload): Promise<void> {
  await api.post('/drivers/me/location', payload);
}
